<template>
  <div class="main-contents">
    <header>
      <div class="header-top-inner">
        <a href="/">
          <div class="item">
            <h1>ハワイPCR検査センター</h1>
          </div>
        </a>
        <div class="item cv">
          <ul>
            <a href="https://lin.ee/BXdbFKG"><li>お問い合わせはこちら</li></a>
            <a href="/contact"><li class="contact-btn">お申し込み</li></a>
          </ul>
        </div>
      </div>
    </header>
    <div id="content01" class="content show">
      <div class="main-visual">
        <a href="/contact">
          <img src="../assets/mv-test-sp20230407.png" class="pcnone">
          <img src="../assets/mv-test-pc20230407.png" class="spnone">
        </a>
      </div>
      <div class="caution-text">
          <p>2022年10月19日(水)の政府発表でワクチンを3回以上接種されていない方は、日本帰国時にPCR検査・陰性証明書が必要になります。<a href="https://www.mofa.go.jp/mofaj/ca/fna/page25_001994.html" style="text-decoration: underline;">詳しくはこちら</a><br><span style="font-size: .6rem;">※ 現地時間5月6日(土)に出国の方はPCR検査・陰性証明書が必要です。5月7日以降はワクチンの有無関わらず、日本帰国時にPCR検査・陰性証明書が必要が無くなります。</span></p>
        </div>
      <div class="feature">
        <div class="feature-inner">
          <div class="fea">
            <i class="fas fa-tasks"></i>
            <h4>手間がない</h4>
            <p class="description">日本人コンシェルジュが予約・決済までサポート！</p>
          </div>
          <div class="fea">
            <i class="fas fa-laptop"></i>
            <h4>オンライン予約</h4>
            <p class="description">日本出発前から検査日時が確定！</p>
          </div>
          <div class="fea">
            <i class="fas fa-language"></i>
            <h4>英語不要</h4>
            <p class="description">日本語対応しているため、スマーズ予約が可能</p>
          </div>
          <div class="fea">
            <i class="fas fa-headset"></i>
            <h4>カスタマーセンター</h4>
            <p class="description">現地で不明な点があった時にすぐにLINEで解決</p>
          </div>
        </div>
      </div>
      <div class="movie" style="margin:5% auto;margin-top:0%;display: block;">
        <h2>クリニックメディア取材</h2>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/LytMGCg4zLE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <p style="font-size: .8em; text-align: left;">※動画内の割引サービスとの併用はできません。あらかじめご了承ください。</p>
      </div>
      <div class="flow">
        <h2>来店検査の証明書取得の流れ</h2>
        <div class="flow-inner">
          <div class="step-wrap4">
            <div class="step-content4">
              <div class="step-label4">STEP</div>
              <div class="step-title4">検査のお申し込み</div>
              <div class="step-body4" style="border-bottom: dotted 2px #ddd;">
                <p>日本へご帰国する搭乗便の72時間以内の検査が必要です。WEBから簡単に検査予約が出来ます。 ご入力いただいた帰国日から日本人コンシェルジュがお客様に最適な日時・場所・プランをご提示いたします。<br><br>日本人コンシェルジュがお客様の帰国時間に基づき、最適なお客様の日本帰国時PCR検査の受検期間※1を<span class="strength">分かりやすく</span>ご提示いたします。<br>※1当日を除く、帰国前72時間以内の範囲で受検可能期間を太字で表示いたします。</p>
              </div>
            </div>
            <div class="step-content4">
              <div class="step-label4">STEP</div>
              <div class="step-title4">お支払い</div>
              <div class="step-body4" style="border-bottom: dotted 2px #ddd;">
                <p>ご提案した受検日時から選択し、お客様情報をご入力いただいたあと、決済画面でクレジットカード情報をご入力いただき、お支払いをお願いいたします。
                  お申し込み完了時にメールアドレスにご予約内容を送信いたします。<label>※ お申し込み完了時に届いたメールを当日受付でお見せください。万が一、メールが届かない場合は<a href="https://lin.ee/BXdbFKG">Line</a>で日本人コンシェルジュにご相談ください。</label></p>
                <p>お支払い方法：オンライン決済(クレジットカード払い)</p>
                <img id="card" src="../assets/card.png">
              </div>
            </div>
            <div class="step-content4">
              <div class="step-label4">STEP</div>
              <div class="step-title4">ご予約日時に検査センターへご来店</div>
              <div class="step-body4" style="border-bottom: dotted 2px #ddd;">
                <p><a href="#place">検査センターはこちら</a></p>
                <p>注意事項：</p>
                <ul>
                  <li>検査を受ける方の<span style="color: red;">パスポート・予約画面(申し込みされた方の申し込み完了メール)</span>をご持参の上、お客様ご自身で検査センターまでお越しください。</li>
                  <li>検査当日に体調不良、38度以上の高熱のあるお客様は検査をお受けいただく事ができません。ご来店になる前に検査センターまでお電話ください。</li>
                </ul>
              </div>
            </div>
            <div class="step-content4">
              <div class="step-label4">STEP</div>
              <div class="step-title4">検体採取は１０分ほどで修了します。(混雑状況によって前後いたします）</div>
            </div>
            <div class="step-content4">
              <div class="step-label4">STEP</div>
              <div class="step-title4">当日中に陰性証明書を添付してメール送信いたします。</div>
              <div class="step-body4" style="border-bottom: dotted 2px #ddd;">※陰性証明書の印刷をご希望の方は、検査結果通知メールをご確認いただいた後、再来店いただきました際にお渡しいたします。お渡しする際は、ご本人様を確認いたしますのでパスポート等身分証明書をご提示いただくようお願いいたします。</div>
            </div>
          </div>
        </div>
      </div>
      <div class="service">
        <h2>サービス概要</h2>
        <p class="description">6時間以内にメールにて検査結果を通知いたします。</p>
        <table class="table">
          <tbody>
            <tr>
              <th class="key">検査センター名称</th>
              <td>ハワイPCR検査センター（相馬クリニックPCRHawaii.com）</td>
            </tr>
            <tr>
              <th class="key">検体採取方法</th>
              <td>鼻腔ぬぐい液</td>
            </tr>
            <tr>
              <th class="key">検査方法</th>
              <td>RTーPCR法</td>
            </tr>
            <tr>
              <th class="key">検査証明書</th>
              <td>厚生労働省の所定フォーマットの陰性検査証明書を発行</td>
            </tr>
            <tr>
              <th class="key">検査料金</th>
              <td>@ワイキキ支店<br>6時間以内：$145から（税込み・陰性証明書費用込み)<br>30分以内(30分最速プラン)：$160（税込み・陰性証明書費用込み)<!--<br><br>@アラモアナ支店<br>3時間以内：$145（税込み・陰性証明書費用込み)<br>-->
                <p class="txt -bold mt--20">キャンセル料/変更料について</p>
                <ul class="list-indent">
                  <li>・事前のご連絡なく、ご予約の時間にお越しいただけなかった場合にはご返金は致しかねます。</li>
                  <li>・検査日1週間以内でのキャンセル・返金を受け付けておりません。</li>
                  <li>・検査時間変更（前日までにご連絡をお願いいたします。ご希望の変更時間に空きがある場合に承ります）</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th class="key"s>検査結果までの時間</th>
              <td>6時間以内にメールにて検査結果を通知いたします。</td>
            </tr>
            <tr>
              <th class="key">医師</th>
              <td>相馬洋一MD</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="place" id="place">
        <h2>検査センターについて</h2>
        <div class="place-info">
          <div class="first">
            <div class="place-inner">
              <div class="pla">
                <img src="../assets/center02.png">
              </div>
              <div class="pla two">
                <p class="title">ハワイPCR検査センターワイキキ支店(相馬クリニック)</p>
                <p class="description">Bank of HawaiiやLongs Drugsがあるカラカウア通りの派手なビルの1Fです。午後が比較的空いていおり、スムーズに検査が可能です。</p>
                <p class="info">
                  住所：2155 Kalaaua Ave, 112 Honolulu, HI 96815<br>検査時間：8:30～18:00（最終受付17時45分）<br>土日も検査可能
                </p>
                <a href="#way1">受付窓口までの順路をご案内</a>
              </div>
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <th>連絡先</th>
                  <td><a href="tel:18083582182">1-(808)  358-2182</a></td>
                </tr>
                <tr>
                  <th>メールでの問い合わせ</th>
                  <td>info@hawaii-pcr-concierge.com</td>
                </tr>
              </tbody>
            </table>
            <div class="box29">
              <div class="box-title" id="way1">ワイキキ支店への行き方</div>
              <div class="access">
                <div class="access-inner">
                  <div class="item">
                    <span>１</span>
                    <img src="https://hawaii.jalpak.net/Opt/Photos/URGENT-1_r_20211103163951.JPG">
                    <p> バンク・オブ・ハワイビルはカラカウア通り沿いにあります。正面の建物がバンク・オブ・ハワイビルの正面玄関になります。</p>
                  </div>
                  <div class="item">
                    <span>２</span>
                    <img src="https://hawaii.jalpak.net/Opt/Photos/SOMA_PCR_02_20220411140754.jpg">
                    <p>1階のロングスドラック横を通り、エレベーターホールを通り越します。</p>
                  </div>
                  <div class="item">
                    <span>３</span>
                    <img src="https://hawaii.jalpak.net/Opt/Photos/SOMA_PCR_03_20220411140912.jpg">
                    <p>左手に写真の入り口がございます。112号になります。</p>
                  </div>
                </div>
              </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3717.774258969061!2d-157.83266708519344!3d21.280401485862676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c006d1185b75551%3A0x21359bf6150e5f2c!2sSoma%20IME%20Clinic!5e0!3m2!1sja!2sjp!4v1657094442181!5m2!1sja!2sjp" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
          <!--
          <div class="first">
            <div class="place-inner">
              <div class="pla">
                <img src="../assets/center02.png">
              </div>
              <div class="pla two">
                <p class="title">ハワイPCR検査センターアラモアナ支店 (相馬クリニック)</p>
                <p class="description">アラモアナセンターに隣接してる最上階に円盤のレストランが目印です。</p>
                <p class="info">
                  住所：1441 Kapiolani Blvd 1115, Honolulu, HI 96814 <br>検査時間：8:30～18:00（最終受付17時45分）<br>土日も検査可能
                </p>
                <a href="">受付窓口までの順路をご案内</a>
              </div>
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <th>連絡先</th>
                  <td><a href="tel:18083582182">1-(808)  358-2182</a></td>
                </tr>
                <tr>
                  <th>メールでの問い合わせ</th>
                  <td>info@hawaii-pcr-concierge.com</td>
                </tr>
              </tbody>
            </table>
           
            <div class="box29">
              <div class="box-title" id="way1">アラモアナ支店への行き方</div>
              <div class="access">
                <div class="access-inner">
                  <div class="item">
                    <span>１</span>
                    <img src="https://stat.ameba.jp/user_images/20220314/06/wellness4hawaii/22/9b/j/o1080144015087501118.jpg?caw=800">
                    <p>アラモアナショッピングセンターの2階からターゲットの方向にお進みいただき、元気寿司、Harry Winstonを探してください。</p>
                  </div>
                  <div class="item">
                    <span>２</span>
                    <img src="https://stat.ameba.jp/user_images/20220314/06/wellness4hawaii/3f/2d/j/o1080144015087501182.jpg?caw=800">
                    <p>駐車場を挟んだ向かい側に白い大きなビルが見えるので中に入りエレベーターで9階に上がり、廊下を右にまっすぐ進んでいただくと1115号室にWellness 4 Hawaiiがあります。</p>
                  </div>
                  <div class="item">
                  </div>
                </div>
              </div>
             
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3717.4808570083974!2d-157.84538338506704!3d21.29200778411513!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c006df03ed34e5d%3A0x975002fdf7af2c1e!2zMTQ0MSBLYXBpb2xhbmkgQmx2ZCAjMTExNSwgSG9ub2x1bHUsIEhJIDk2ODE0IOOCouODoeODquOCq-WQiOihhuWbvQ!5e0!3m2!1sja!2sjp!4v1658789611209!5m2!1sja!2sjp" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>-->
        </div>
      </div>
      <div class="place" id="place">
        <h2>FAQ</h2>
        <div class="faq-inner">
          <div class="cp_qa">
            <div class="cp_actab">
              <input id="cp_tabfour021" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour021">陰性証明書の発行にはどのくらい時間がかかりますでしょうか？</label>
              <div class="cp_actab-content">検査終了後から半日~1日かかる形です。発行完了しますとメールにてpdfで届きます。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour024" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour024">入金後の返金はございますでしょうか？</label>
              <div class="cp_actab-content">検査日から1週間以内でのキャンセル・返金は受付しておりません、万が一キャンセルされる場合は1週間前までにご連絡をこちらのメールに連絡ください。事務局からご連絡いたします。(info@hawaii-pcr-concierge.com)また政府等の意向により検査が必要なくなった場合は返金をさせていただきます。※ただしレートは1ドル130円で計算いたします。(安心返金保証)</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour025" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour025">場所がわからない場合はどうすれば良いでしょうか？</label>
              <div class="cp_actab-content">営業時間内に各検査所にご連絡ください。日本語で対応いたします。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour026" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour026">お申し込み完了後にメールが届かないのですがどうすればよろしいでしょうか。</label>
              <div class="cp_actab-content">メールソフトの設定により、迷惑メールフォルダに入っている可能性がございます。迷惑メールフォルダにもない場合は、以下のLineからお問い合わせください。</div>
            </div>

            <div class="cp_actab">
              <input id="cp_tabfour027" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour027">いつ検査を受けたら有効かわからない。</label>
              <div class="cp_actab-content">当予約システムでは、帰国日時をご入力いただくと、有効となる検査期間が表示されるようになっております。ご都合ご確認の上検査ご希望日をご選択ください。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour028" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour028">当日の持ち物について</label>
              <div class="cp_actab-content">検査当日は受付にてパスポートとご決済後にお送りする領収メールの画面をご提示いただきますので、ご準備ください。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour029" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour029">予約時間は現地時間ですか？</label>
              <div class="cp_actab-content">ご予約日時など、当サイトに表記の日時はすべてハワイ現地時間となります。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour030" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour030">予約日時を変更したい。</label>
              <div class="cp_actab-content">LINEにて【氏名】【メールアドレス】【予約検査日時】【領収ナンバーor決済未完了】【変更後検査希望日時】をご記載の上お申し付けください。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour031" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour031">決済前に画面を閉じてしまった。</label>
              <div class="cp_actab-content">LINEもしくは予約確定メールにご返信いただくか、＜info@hawaii-pcr-concierge.com＞まで【氏名】【メールアドレス】【予約検査日時】をお知らせの上、ご決済未完了の旨お伝えください。ご決済用リンクをお送りいたします。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour032" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour032">予約確定メールが届かない。</label>
              <div class="cp_actab-content">メールソフトの設定により、迷惑メールフォルダに入っている可能性がございます。迷惑メールフォルダにもない場合は、以下のLINEから【氏名】【メールアドレス】【予約検査日時】をご記載の上お問い合わせください。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour033" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour033">決済したが、完了メールが届かない。</label>
              <div class="cp_actab-content">メールソフトの設定により、迷惑メールフォルダに入っている可能性がございます。迷惑メールフォルダにもない場合は、以下のLINEから【氏名】【メールアドレス】【予約検査日時】をご記載の上お問い合わせください。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour034" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour034">領収書を別のメールアドレスに再送信できますか。</label>
              <div class="cp_actab-content">可能でございます。【氏名】【メールアドレス】をご記載の上LINEにてお申し付けください。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour035" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour035">キャンセルしたい。</label>
              <div class="cp_actab-content">弊社のキャンセルポリシーは（キャンセルポリシー）となっております。1週間以上前のキャンセルもしくは政府指針により不要となった場合のみ、返金の手続きをさせていただきます。
　予約確定メールにご返信いただくか、＜info@hawaii-pcr-concierge.com＞まで【氏名】【メールアドレス】【予約検査日時】【領収ナンバーor決済未完了】をご記載の上キャンセルをご用命ください。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour036" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour036">結果が陽性だった場合はどうなりますか。</label>
              <div class="cp_actab-content">仮に陽性となってしまわれた場合についてはクリニックで診察診断、隔離の案内及び、隔離期間後の回復証明書発行なども日本人医師よりさせていただけますが、こちらは直接クリニックとやり取りとなります。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour037" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour037">現金は使えますか？</label>
              <div class="cp_actab-content">誠に恐れ入りますが、ご決済につきましてはクレジットカード（Visa・MasterCard・American Express）のみとなっております。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour038" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour038">駐車場はありますか？</label>
              <div class="cp_actab-content">あいにく提携の駐車場はございません。お近くですと以下のリンクのバレー駐車が便利でございます。ワイキキ・ビーチ・ウォークのショップやレストランで$10以上ご利用の方は、当日に限り無料でバレー駐車サービスがご利用可能でございます。
お買い物等のご予定と合わせてご参考になれば幸いです。<br><a href="http://jp.waikikibeachwalk.com/Parking.htm">> 詳しくはこちら</a></div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour039" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour039">陰性証明書は紙が必要でしょうか。</label>
              <div class="cp_actab-content">陰性証明書は紙をおすすめしておりますがどうしてもの方はPDFにて航空会社にご提示お願いします。航空会社ハワイアン、日本航空、ANAともPDFにて搭乗出来ております。紙の印刷についてはご来店いただけましたら無料にてお出ししております。</div>
            </div>
            <div class="cp_actab">
              <input id="cp_tabfour040" type="checkbox" name="tabs">
              <div class="cp_plus">+</div>
              <label for="cp_tabfour040">検査はどのような方法ですか？</label>
              <div class="cp_actab-content">鼻腔ぬぐいによるRTーPCR法になります。採取は医師、看護師が行います。</div>
            </div>


          </div>
        </div>
      </div>
      <!--
      <div class="place caution-area" id="place">
        <h2>注意事項</h2>
        <div>
          <p>・8/24(水)の政府発表で入国時水際対策が変更されました。<a href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/0000121431_00209.html">詳しくはこちら</a></p>
        </div>
        
      </div>-->
    </div>
    <div id="content02" class="content">
    </div>
    <div class="bnr">
      <div class="bnr-inner">
        <div class="b">
          <a href="tel:03-4400-1511"><img src="../assets/tel-bnr.jpeg"></a>
        </div>
        <div class="b">
          <a href="https://lin.ee/BXdbFKG"><img src="../assets/line-bnr.jpeg"></a>
        </div>
      </div>
    </div>
    <footer style="text-align: center;">
      Copyright © 2022 Kirarin.Co.,Ltd.
    </footer>
    <div style="text-align: center;">
      <div class="pcnone banner">
        <div class="" style="text-align: center;">
           <a href="/contact"><div class="contact-btn">お申し込み</div></a>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
a{text-decoration: none;}
h1{
  font-family: M PLUS Rounded\ 1c,sans-serif;
  font-weight: bolder!important;
}
h1, h2 {
  font-weight: normal;
  margin: 0px!important;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: white;
}
.step-content4 a{
  color: #196FB9;
}
#place a{
   color: #196FB9;
}
h1 img{
  width: 100%!important;
}
body{
  margin: 0 auto!important;
}
h1{
padding: 16px;
}
header{
  background: #196FB9;
}
.spnone{
  display: block;
}
.pcnone{
  display: none;
}
.main-visual img{width: 100%;}
.header-top-inner{
  display: flex;
  justify-content: space-between;
  padding: 16px;
  padding-top: 0px;
  padding-bottom: 0px;
  color: white;
}
.header-top-inner .item{
  color: white;
}
.header-bottom-inner {
  display: flex;
  margin: 0 auto;
  width: 60%;
}
.header-bottom-inner .item{
  width: 50%;
}
.movie iframe{
  margin: 5% auto;
  margin-bottom: 0px;
}
.movie p{
  width: 40%;
    margin: 0 auto;
}
.feature{
}
.feature h2{

    font-size: 2em;
    line-height: 0.6em;
    font-weight: 800;
    font-style: normal;
    letter-spacing: .1em;
    text-align: center;
    width: 100%;
    color: coral;
    white-space: nowrap;
    padding-bottom: 8px;
    margin-bottom: 16px;
}
.contact h2{

    font-size: 2em;
    line-height: 0.6em;
    font-weight: 800;
    font-style: normal;
    letter-spacing: .1em;
    text-align: center;
    width: 100%;
    color: coral;
    white-space: nowrap;
    padding-bottom: 8px;
    margin-bottom: 16px;
}

.caution-text p{
  padding: 2em;
    background: indianred;
    margin: 0px;
    color: white;
}

/* CTA_05 */

.cta05-cvset {
    padding: 100px 0 0;
    width: 90%;
    margin: 0 auto;
}

.cta05-cvset .cta05-inner {
    background-color: #f4fcf4;
    padding: 10px 0 20px;
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
}

.cta05-cvset .cta05-inner ul {
    list-style:none;
    margin-top: 40px;
    padding-inline-start:0;
    border: none;
    padding: 0;
}

.cta05-cvset-title {
    position: relative;
    font-size: 1.8em;
    line-height: 0.6em;
    font-weight: 800;
    font-style: normal;
    letter-spacing: .1em;
    position: absolute;
    top: -10px;
    left: 0;
    text-align: center;
    width: 100%;
}
.cta05-cvset-title .deco {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    color: coral;
    white-space: nowrap;
    padding-bottom: 8px;
    margin-bottom: 16px;
}
.caution-area{
  width: 60%;
    margin: 0 auto;
    display: block;
    text-align: left;
}

.cta05-cvset-title .deco:before, .cta05-cvset-title .deco:after {
    display: inline-block;
    position: absolute;
    top: 42%;
    width: 28px;
    height: 2px;
    border-radius: 3px;
    background-color: coral;
    content: "";
    margin: auto -35px;
}
.cta05-cvset-title .deco:before {
    left: 0;
    -webkit-transform: rotate(50deg);
    transform: rotate(50deg);
}

.cta05-cvset-title .deco:after {
    right: 0;
    -webkit-transform: rotate(-50deg);
    transform: rotate(-50deg);
}

.cta05-cvset-list {
    display: flex;
    width: 100%;
    max-width: 780px;
    justify-content: space-between;
    margin: 0 auto;
}
.cta05-cvset-list li {
    max-width: 360px;
    width: 100%;
    margin: 0 5px;
}
.cta05-cvset-list img {
    width:100%;
    text-align:center;
}
.cta05-button.dwl, .cta05-button.etm {
    background-color: #fff;
    border: 3px solid #005fa0;
    color: #005fa0;
}
.cta05-button.dwl, .cta05-button.dmo, .cta05-button.etm {
    height: 56px;
    font-size: 24px;
    font-weight: bold;
    line-height: 1.4em;
    text-align: center;
    flex-direction: column;
    white-space: nowrap;
    text-decoration: none;
}
.cta05-button.dmo {
    background: linear-gradient(#217669, #224364);
    border: 0px solid #005fa0;
    color: #fff;
    width: 80%;
    margin: 5% auto;
}
.cta05-button {
    position: relative;
    display: flex;
    width: 100%;
    height: 72px;
    text-align: center;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    border-radius: 12px;
    margin: 0;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 6px 10px -2px rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.2);
    transition: 0.2s ease-in-out;
}
.cta05-button.free::after {
    content: "無料";
    position: absolute;
    display: block;
    top: -17px;
    right: 8px;
    width: 80px;
    height: 30px;
    font-size: 16px;
    font-weight: bold;
    line-height: 32px;
    text-align: center;
    background-color: coral;
    color: #fff;
    border-radius: 16px;
}
.cta05-button.dwl:hover, .cta05-button.dmo:hover, .cta05-button.etm:hover {
    background-color: #6bb6ff;
    box-shadow: 0 15px 30px -5px rgba(0, 0, 0, 0.15), 0 0 5px rgba(0, 0, 0, 0.1);
    transform: translateY(-4px);
}
.cta05-button.dwl small, .cta05-button.dmo small, .cta05-button.etm small {
    display: block;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2em;
    letter-spacing: 0;
    margin-bottom: 4px;
    white-space: nowrap;
}
.cta05-cvset-list span{
  font-weight: 700;
}
@media screen and (max-width: 768px){
  .movie p{
  width: 90%;
    margin: 0 auto;
}


.caution-text p{
  padding: 1em;
    background: indianred;
    margin: 0px;
    text-align: left;
    font-size: .8em;
    color: white;
}



.cta05-cvset .cta05-inner {
    padding: 40px 20px 32px;
}
.movie iframe{
  width: 100%;
}
.cta05-cvset-list {
    flex-direction: column;
    align-items: center;
    padding-bottom: 16px;
}
.cta05-button.dwl small, .cta05-button.dmo small, .cta05-button.etm small {
    font-size: 12px;
}
}
/* container */
.wrapper{
    width:100%;
    background-color:transparent;
}
.wrapper .container{
    max-width:1000px;
    margin:0px auto;
    padding:80px 0px;
}
/* content */
@media (min-width: 992px) {
    .wrapper .container .content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90%;
    margin: 0 auto;
    }
}
.wrapper .content-item {
    width:100%;
}
@media (min-width: 992px) {
    .wrapper .content-item {
        width:50%;
    }
}
.wrapper .image{
    display:block;
    max-width:100%;
    margin:0px auto;
}
.wrapper .text{
    padding:50px;
}
.wrapper .text .heading{
    margin:0px 0px 40px 0px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
}

/* container */
.wrapper2{
    width:100%;
    background-color:transparent;
}
.wrapper2 .container{
    max-width:1000px;
    margin:0px auto;
    padding:80px 0px;
}
#card{
  width: 60%;
}
/* content */
@media (min-width: 992px) {
    .wrapper2 .container .content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90%;
    margin: 0 auto;
    }
   
}
/* co
}
/* PC時のみ順番を入れ替える */
@media (min-width: 992px) {
    .wrapper2 .content {
        flex-direction:row-reverse;
    }
}
.wrapper 2.content-item {
    width:100%;
}
@media (min-width: 992px) {
    .wrapper2 .content-item {
        width:50%;
    }
}
.wrapper2 .image{
    display:block;
    max-width:100%;
    margin:0px auto;
}
.wrapper2 .text{
    padding:50px;
}
.wrapper2 .text .heading{
    margin:0px 0px 40px 0px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
}
.text p{
  line-height: 2em;
}

#feedback-page{
  text-align:center;
}

#form-main{
  width:100%;
  float:left;
  padding-top:0px;
}

#form-div {
  background-color: rgba(72,72,72,0.4);
    padding-left: 35px;
    padding-right: 35px;
    padding-top: 35px;
    padding-bottom: 50px;
    width: 80%;
    /* float: left; */
    display: block;
    /* left: 50%; */
    margin: 0 auto;
    /* position: absolute; */
    margin-top: 30px;
    /* margin-left: -260px; */
    -moz-border-radius: 7px;
    -webkit-border-radius: 7px;
}

.feedback-input {
  color:#3c3c3c;
  font-family: Helvetica, Arial, sans-serif;
  font-weight:500;
  font-size: 18px;
  border-radius: 0;
  line-height: 22px;
  background-color: #fbfbfb;
  padding: 13px 13px 13px 13px;
  margin-bottom: 10px;
  width:100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
  border: 3px solid rgba(0,0,0,0);
}

.feedback-input:focus{
  background: #fff;
  box-shadow: 0;
  border: 3px solid #3498db;
  color: #3498db;
  outline: none;
  padding: 13px 13px 13px 13px;
}

.focused{
  color:#30aed6;
  border:#30aed6 solid 3px;
}
textarea {
    width: 100%;
    height: 150px;
    line-height: 150%;
    resize:vertical;
}

input:hover, textarea:hover,
input:focus, textarea:focus {
  background-color:white;
}

#button-blue{
  font-family: 'Montserrat', Arial, Helvetica, sans-serif;
  float:left;
  width: 100%;
  border: #fbfbfb solid 4px;
  cursor:pointer;
  background: linear-gradient(#217669, #224364);
  color:white;
  font-size:24px;
  padding-top:22px;
  padding-bottom:22px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  margin-top:-4px;
  font-weight:700;
}

#button-blue:hover{
  opacity: 0.7;
}
.submit:hover {
  opacity: 0.7;
}
.ease {
  width: 0px;
  height: 74px;
  background-color: #fbfbfb;
  -webkit-transition: .3s ease;
  -moz-transition: .3s ease;
  -o-transition: .3s ease;
  -ms-transition: .3s ease;
  transition: .3s ease;
}

.submit:hover .ease{
  width:100%;
  background-color:white;
}

@media only screen and (max-width: 580px) {
  #form-div{
    left: 3%;
    margin-right: 3%;
    width: 88%;
    margin-left: 0;
    padding-left: 3%;
    padding-right: 3%;
  }
}
.contact{
  background-color:transparent;
}
.form-inner{
  background-color:transparent;
}

@media only screen and (max-width: 1080px) {
body {
    width: 100%!important;
}
.spnone{
  display: none;
}
.pcnone{
  display: block;
}
.wrapper .container {
    padding: 0px;
}
.wrapper {
    margin-top: 10%;
    }
.wrapper2 .container {
    padding: 0px;
}
#form-div {
    left: 0%;
    margin-right: initial;
    width: 88%;
    display: block;
    margin: 10% auto;
}
.cta05-cvset .cta05-inner {
    padding: 16px;
}
.cta05-cvset .cta05-inner {
  width: initial;
  }
  .cta05-cvset-title {
    font-size: 1.2em;
    top: -5px;
  }
}
.header-bottom-inner{display: flex; width: 80%; justify-content: space-between;color: white; font-weight: bold;}
.header-bottom-inner .btn-inner{display: contents;}
.header-bottom-inner .item{width: 80%;margin: 16px auto;font-size: 1.2em;border-radius: 20px;}
.selected {background: #5b97cd;}
.content{display: none;}
.show{display: block;}
.feature{padding: 5%;}
.feature-inner{display: flex;justify-content: space-between;}
.fea{width: 23%;}
.fa, .fas {font-size: 3em;color: #196FB9;}
h2{
  position: relative;
    font-family: "M PLUS Rounded 1c", sans-serif;
    font-weight: bold;
    color: #196FB9;
    text-align: center;
    font-size: 2rem;
    margin: 93px 0 40px;
    padding: 0 20px 30px;
}
h2:after {
    position: absolute;
    bottom: 0;
    left: 50%;
    display: block;
    content: "";
    width: 80px;
    height: 5px;
    background-color: #196FB9;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    -webkit-transform: translate(-50%, 0);
    -moz-transform: translate(-50%, 0);
    -ms-transform: translate(-50%, 0);
    -o-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
}
.service table{
  margin: 2% auto;
  width: 60%;
}
.table th {
    border-top: 1px solid #fff;
    background-color: #196FB9;
    text-align: center;
    color: #fff;
    padding: 15px;
}
.table td {
    border-top: 1px solid #fff;
    border-left: 1px solid #fff;
    background-color: #F1F7FC;
    color: #196FB9;
    padding: 15px 40px;
    text-align: left;
}
.table .key{
  width: 30%;
}
.service .description{text-align: left;width: 60%; margin:16px auto;}
.flow-inner{ width: 50%;margin: 0 auto;}
.place-inner{ display: flex;justify-content: space-between;width: 60%;margin: 0 auto;  }
.place-info{margin: 5% auto;}
.pla{width: 50%;}
.pla img{width: 100%;}
.place-info table{
  margin: 0 auto;
  width: 60%;
}
.place-info .first{margin-bottom: 5%;}
.service{margin-bottom: 5%;}
.flow{margin-bottom: 5%;}
.place{margin-bottom: 5%;}
.feature{margin-bottom: 5%;}
.contact-btn{
  background: orange;
    border-radius: 20px;
    padding: 8px;
    padding-left: 36px;
    padding-right: 36px;
    letter-spacing: .2em;
}
.two{
  padding: 24px;
    text-align: left;
}
.two .title{
  font-size: 1.5em;
    font-weight: bold;
    color: #196FB9;
}
@media only screen and (max-width: 1080px) {
  .step-body4 img{
    width: 100%;
  }
  .flow-inner {
    width: 90%;
  }
  .service .description {
    width: 90%;
  }
  .service table {
    width: 90%;
  }
  .place-inner {
     width: 90%;
   }
   .feature-inner{
    display: block;
   }
   .fea {
    width: 80%;
    margin: 10% auto;
}
.cv{display: none;}
table th,
table td{

  width:100%;

  display:block;
  width: 90%;

}
.table td {
    padding: 0px;
    width: 100%;

}
.table .key {
    width: 92%;
}
.place-inner {
    width: 90%;
    display: block;
}
.pla {
    width: 100%;
}
.place-info table {
    margin: 0 auto;
    width: 90%;
}
.first .table td {
    padding: 0px;
    width: 98%;
}
.two {
    padding: 0px;
    margin: 5% auto;
    text-align: left;

}
.place-info .first {
    margin-bottom: 15%;
}
.place {
    margin-bottom: 15%;
}
.service {
    margin-bottom: 15%;
}
.flow {
    margin-bottom: 15%;
}
.banner .contact-btn{
  display: block;
    width: 300px;
}
}
.step-wrap4 {
 counter-reset: count;
 margin: 2em 0;
 position: relative;
}
.step-content4 {
 padding: 1em 0 1.3em 2.5em;
 margin: 0;
 text-align: left;
 position: relative;
}
.step-content4::before {
 content: "";
 display: block;
 width: 55px;
 height: 55px;
 background: #759bcc;
 border-radius: 50%;
 position: absolute;
 top: 0;
 left: -3px;
}
.step-content4::after {
 content: "";
 display: block;
 height: calc(100% - 55px);
 border-left: solid 2px #ddd;
 position: absolute;
 top: 55px;
 left: 10px;
}
.step-label4 {
 color: #fff;
 font-weight: bold;
 font-size: 12px;
 position: absolute;
 top: 6px;
 left: 9px;
}
.step-label4::after {
 counter-increment: count;
 content: counter(count);
 position: absolute;
 font-size: 30px;
 top: 8px;
 left: 7px;
}
.step-title4 {
 font-weight: bold;
 font-size: 120%;
 margin-left: 1.5em;
}
.step-body4 {
 margin-top: 1em;
 padding: 0 0 1em;
 border-bottom: dotted 2px #ddd;
}
.step-wrap4 > :last-of-type::after {
 display: none;
}
/***ステップバーデザイン４***/
.banner{
  background: transparent;
    padding: 0px;
    position: fixed;
    bottom: 0px;
    width: 100%;
    padding: 0px;
}
.eme-btn{
  background: #196FB9;
  border-radius: 20px;
  padding: 8px;
}
.banner li{
  padding-left: 0px;
}
.banner .contact-btn {
    margin: 8px auto;
    padding: 8px;
}
.cp_qa *, .cp_qa *:after, .cp_qa *:before {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
.cp_qa {
  overflow-x: hidden;
  margin: 0 auto;
  color: #196FB9;
}
.cp_qa .cp_actab {
  padding: 20px 0;
  border-bottom: 1px dotted #cccccc;
}
.cp_qa label {
  font-size: 1.2em;
  position: relative;
  display: block;
  width: 100%;
  margin: 0;
  padding: 10px 10px 0 48px;
  cursor: pointer;
}
.cp_qa .cp_actab-content {
  font-size: 1em;
  position: relative;
  overflow: hidden;
  height: 0;
  margin: 0 40px;
  padding: 0 14px;
  -webkit-transition: 0.4s ease;
          transition: 0.4s ease;
  opacity: 0;
}
.cp_qa .cp_actab input[type=checkbox]:checked ~ .cp_actab-content {
  height: auto;
  padding: 14px;
  opacity: 1;
}
.cp_qa .cp_plus {
  font-size: 2.4em;
  line-height: 100%;
  position: absolute;
  z-index: 5;
  margin: 3px 0 0 10px;
  -webkit-transition: 0.2s ease;
          transition: 0.2s ease;
}
.cp_qa .cp_actab input[type=checkbox]:checked ~ .cp_plus {
  -webkit-transform: rotate(45deg);
          transform: rotate(45deg);
}
.cp_qa .cp_actab input[type=checkbox] {
  display: none;
}
.faq-inner{
  width: 60%;
    margin: 5% auto;
}
.strength{
  color: orangered;
    font-size: 1.2em;
    font-weight: bold;
}
.place-inner iframe{
  margin:0px auto;
    width: 100%;
}
.access-inner{
  width: 100%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.access-inner .item{
width: 30%;
position: relative;
}
.access-inner .item span{
  position: absolute;
    top: 8px;
    left: 8px;
    font-size: 1.5em;
    padding: 4px;
    background: #196FB9;
    color: white;
}
.box29 {
    margin: 2em 0;
    background: #dcefff;
    width: 60%;
    margin: 2% auto;
    display: grid;

}
.box29 .box-title {
    font-size: 1.2em;
    background: #5fb3f5;
    padding: 4px;
    text-align: center;
    color: #FFF;
    font-weight: bold;
    letter-spacing: 0.05em;
}
.access{padding: 5%;}
.access-inner img{
  width: 100%;
}
.access-inner p{
  text-align: left;
}
.bnr{width: 60%; margin: 5% auto;}
.bnr-inner{display: flex; justify-content: space-between;}
.b img{width: 100%}
.b img:hover{opacity: 0.7;}
.b{width: 48%;}

@media only screen and (max-width: 1080px) {
  .faq-inner{
  width: 90%;
}
 .caution-area{
      width: 90%;
    }
.header-top-inner{
  display: none;
}
.box29 {
    width: 90%;
    }
    .access-inner .item {
    width: 48%;
  }
.bnr-inner{
  display: block;
    width: 100%;
  }
  .b {
    width: 95%;
    margin: 5% auto;
}
.bnr {
    width: initial;
    margin: 10% auto;
}
 #card{
  width: 100%;
}
}
</style>
<script>
export default {
  name: 'Top',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted: function () {
    document.getElementById('content01').classList.add('show')
  },
  methods: {
    btn01: function () {
      document.getElementById('btn02').classList.remove('selected')
      document.getElementById('btn01').classList.add('selected')
      document.getElementById('content01').classList.add('show')
      document.getElementById('content02').classList.remove('show')
    },
    btn02: function () {
      document.getElementById('btn01').classList.remove('selected')
      document.getElementById('btn02').classList.add('selected')
      document.getElementById('content01').classList.remove('show')
      document.getElementById('content02').classList.add('show')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Test.vue